import "./InfoHeader.scss";
import Avatar from "core/avatar/Avatar";
import BackupModal from "components/modal/BackupModal";
import BorderlessButton from "core/buttons/borderless-button/BorderlessButton";
import Button from "core/buttons/button/Button";
import ClientDeleteWarningModal from "components/modal/ClientDeleteWarningModal";
import DeleteModal from "components/modal/DeleteModal";
import Dropdown from "core/dropdown/Dropdown";
import DropdownLinkItem from "core/dropdown/DropdownLinkItem";
import InfoContext from "pages/InfoContext";
import { useCurrencyContext } from "api/settings/currency/CurrencyProvider";
import InputPicture from "core/inputs/input-picture/InputPicture";
import Label from "core/label/Label";
import ManageCompanyHistory from "components/tables-contents/ManageCompanyHistory";
import ManageDailyFee from "components/tables-contents/ManageDailyFee";
import ManageHistoryManagers from "components/tables-contents/ManageHistoryManagers";
import ManageJobHistory from "components/tables-contents/ManageJobHistory";
import ManageLongLeave from "components/tables-contents/ManageLongLeave";
import ManageManagers from "components/tables-contents/ManageManagers";
import ManagePositionCoefficient from "components/tables-contents/ManagePositionCoefficient";
import ManageSalary from "components/tables-contents/ManageSalary";
import ManageWorkContract from "components/tables-contents/ManageWorkContract";
import Modal from "components/modal/Modal";
import ToggleButton from "core/buttons/toggle-button/ToggleButton";
import robot from "assets/images/robot.svg";
import CategoryTag from "core/tags/category-tag/CategoryTag";
import { FormattedMessage } from "react-intl";
import {
  INFO_HEADER_NAVIGATION,
  ENTITY,
  HEADER_NAVIGATION,
} from "constants/info-header";
import {
  ACTIONS,
  IA_PROFILE,
  MGR_PROFILE,
  MODAL_CONTENT,
  QUERY_STATUS,
  SCOPES,
  SECTIONS,
} from "constants/constants";
import { OnClickOutside } from "utils/functions";
import { canUserPerformAction } from "access-roles/general-functions";
import {
  getMissionStatusColor,
  getMissionStatusTagLabel,
} from "utils/consultantHelper";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfilePictureHandler, useWindowSize } from "utils/customHooks";
import ManageBillingClientHistory from "components/tables-contents/ManageBillingClientHistory";
import { enableValidateConsultantEmail } from "access-roles/consultant/functions";
import { enableMascarade } from "access-roles/staff/functions";
import {
  billingClientDropDownList,
  clientDropdownList,
  consultantDropdownList,
  getModalMessageId,
  getModalTitle,
  missionDropDownList,
  staffDropdownList,
  subCompanyDropdownList,
  subcontratorDropdownList,
} from "utils/HeaderHelper";
import { useMissionContext } from "api/mission/MissionProvider";
import PropTypes from "prop-types";
import { useFileContext } from "api/files/FilesProvider";
import ManageExternalTraining from "components/tables-contents/ManageExternalTraining";
import { useUserContext } from "api/user/UserProvider";
import { useConsultantContext } from "api/directory/consultant/ConsultantProvider";
import { useStaffContext } from "api/directory/staff/StaffProvider";
import { useSubcontractorContext } from "api/directory/subcontractor/SubcontractorProvider";
import { useClientContext } from "api/directory/client/ClientProvider";
import { useSubcontractorCompanyContext } from "api/directory/subcontractor-company/SubcontractorCompanyProvider";
import { useBillingClientContext } from "api/directory/billing-client/BillingClientProvider";
import { useUserDatatrackContext } from "api/datatrack/UserDatatrackProvider";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import ValidationModal from "components/modal/ValidationModal";
import { ROLE_GET_TIMELINE } from "access-roles/roles";
import {
  formatBillingClient,
  formatClient,
  formatConsultant,
  formatMission,
  formatStaff,
  formatSubcontractingCompany,
  formatSubcontractor,
} from "utils/formatters";
import { useMissionFeeContext } from "api/mission/mission-fee/MissionFeeProvider";
import { useMissionManagerContext } from "api/mission/mission-manager/MissionManagerProvider";
import _ from "lodash";
import { useBillingClientDatatrackContext } from "api/datatrack/client/BillingClientDatatrackProvider";

const InfoHeader = ({
  getModalInfo,
  onValidate,
  modalType,
  setModalType,
  userDatatrack,
  getManagersContract,
  missionFeeByMissionId,
  missionManagerByMissionId,
  historySubCompany,
  subcontractorCompanies,
  user,
  searchBillingClient,
  billingClients,
  mascaradeAs,
  userScope,
  searchSubcontractorCompanyByName,
  canMascarade,
  domainList,
  historyBillingClientByClientId,
  billingClientsByIds,
  setElementsToDelete,
  elementsToDelete,
  isManagerActiveContract,
  managersContracts,
  setManagersContracts,
  missionIsBackupable,
  connectedUser,
  setCode,
  setStatus,
  historyManagersNames,
  entitySlug,
  entityStatus,
  managersNames,
  userCoefPositionList,
}) => {
  const [isOpenValidationModal, setIsOpenValidationModal] = useState(false);
  const [activeSection, setActiveSection] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);
  const pendingDeleteRef = useRef(false);
  const [isOpenBackupModal, setIsOpenBackupModal] = useState(false);
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const [isShowing, setIsShowing] = useState(false);
  const [listening, setListening] = useState(false);

  useEffect(() => {
    if (!isShowing) {
      setApiErrorResponse(null);
    }
  }, [isShowing]);
  const [modalHeaderInfo, setModalHeaderInfo] = useState({});
  const [updatedData, setUpdatedData] = useState([]);
  const {
    billingClientBySlug,
    branches,
    changedActiveSection,
    clientBySlug,
    davFunctions,
    defaultCurrency,
    deleted,
    entity,
    id,
    isEnabled,
    lang,
    leavingReasons,
    missionById,
    missionStatus,
    onDelete,
    openSalaryModal,
    setOpenSalaryModal,
    openManageExternalTrainingModal,
    setOpenManageExternalTrainingModal,
    personsList,
    readOnly,
    setIsEnabled,
    setReadOnly,
    setSection,
    subcontractorCompany,
    syntecCoef,
    userBySlug,
    usersByIds,
    setMissionCreated,
    contractualStatusList,
    externalTraining,
    apiErrorResponse,
    availableDocuments,
    getDocument,
    getDocumentStatus,
    creationFileStatus,
    missionQuoteStatus,
    consultantBySlug,
    assignedClients,
    isCSE,
    setIsCSE,
    isPracticeLeader,
    setIsPracticeLeader,
    timelineMissionsList,
    timelineQueryStatus,
    openModalIntent,
    setOpenModalIntent,
  } = useContext(InfoContext);
  const { getNamesByFilters } = useGeneralContext();
  const { userRoleList } = useUserContext();
  const { staffAccessRights } = useStaffContext();
  const { consultantAccessRights } = useConsultantContext();
  const { subcontractorAccessRights, subcontractorBySlug } =
    useSubcontractorContext();
  const { clientAccessRights } = useClientContext();
  const { setMissionFeeEditStatus } = useMissionFeeContext();
  const { setMissionManagerStatus } = useMissionManagerContext();
  const { setBillingClientStatus } = useBillingClientDatatrackContext();
  const { subcontractingCompanyAccessRights, getSubcontractorsListExport } =
    useSubcontractorCompanyContext();
  const {
    getModalAccessForDatatrack,
    setApiErrorResponse,
    setUserDatatrackStatus,
    userDatatrackStatus,
  } = useUserDatatrackContext();
  const { billingClientAccessRights } = useBillingClientContext();
  const { setCreatedFile, createFile } = useFileContext();
  const { currencyListByBranch, currencyListByBranchGetter } =
    useCurrencyContext();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const size = useWindowSize();
  const {
    missionAccessRights,
    getMissionQuote,
    getModalAccessForMissions,
    handleDownloadMissionPPT,
  } = useMissionContext();
  const { picture } = useProfilePictureHandler();
  const [isMascarade, setIsMascarade] = useState(false);
  const [isMobile, setIsMobile] = useState(size.width < 1706);
  const [currencyDefault, setCurrencyDefault] = useState([]);
  const [modalAccessData, setModalAccessData] = useState(null);
  const [modalDatatrackAccessData, setModalDatatrackAccessData] =
    useState(null);

  const hasDatatrackModalAccess =
    modalDatatrackAccessData &&
    Object.values(modalDatatrackAccessData).some(
      ({ get, update }) => get || update
    );

  const firstTabSection = INFO_HEADER_NAVIGATION[entity]?.[0]?.section;
  const isOnFirstTab = !activeSection || activeSection === firstTabSection;

  const entityFormatters = {
    [ENTITY.CONSULTANT]: formatConsultant({ id: user?.id }),
    [ENTITY.STAFF]: formatStaff({
      id: user?.id,
      branch_id: user?.branch_id,
      profile_id: user?.profile_id,
    }),
    [ENTITY.SUBCONTRACTOR]: formatSubcontractor({
      subcontractorCompany,
      id: user?.id,
    }),
    [ENTITY.CLIENT]: formatClient({
      analytical_code: clientBySlug?.analytical_code,
    }),
    [ENTITY.SUBCONTRACTING_COMPANY]: formatSubcontractingCompany({
      siren: subcontractorCompany?.siren,
    }),
    [ENTITY.BILLING_CLIENT]: formatBillingClient({
      siren: billingClientBySlug?.siren,
    }),
    [ENTITY.MISSION]: formatMission({
      analytical_code: missionById?.analytical_code,
    }),
  };

  const entityTagConfig = {
    [ENTITY.CONSULTANT]: {
      type: "cslt",
      messageId: "entity_tag_consultant",
      defaultMessage: "Consultant",
    },
    [ENTITY.STAFF]: {
      type: "people",
      messageId: "staff_tag",
      defaultMessage: "Staff",
    },
    [ENTITY.SUBCONTRACTOR]: {
      type: "str",
      messageId: "subcontractor_tag",
      defaultMessage: "Sous-traitant",
    },
    [ENTITY.CLIENT]: {
      type: "clients",
      messageId: "client_tag",
      defaultMessage: "Client",
    },
    [ENTITY.BILLING_CLIENT]: {
      type: "billing_clients",
      messageId: "billing_client_tag",
      defaultMessage: "Société de facturation",
    },
    [ENTITY.SUBCONTRACTING_COMPANY]: {
      type: "subcontracting_company",
      messageId: "subcontracting_company_tag",
      defaultMessage: "Société sous-traitante",
    },
    [ENTITY.MISSION]: {
      type: "standard",
      messageId: "mission_tag",
      defaultMessage: "Mission",
    },
  };

  const initSection = () => {
    if (
      entity === ENTITY.CLIENT ||
      entity === ENTITY.BILLING_CLIENT ||
      entity === ENTITY.MISSION
    ) {
      setActiveSection(SECTIONS.GENERAL_INFO);
      setSection(SECTIONS.GENERAL_INFO);
    } else {
      setActiveSection(SECTIONS.PERSONAL);
      setSection(SECTIONS.PERSONAL);
    }
  };

  useEffect(() => {
    user?.branch_id && currencyListByBranchGetter(user?.branch_id);
  }, [user?.branch_id]);

  useEffect(() => {
    setCurrencyDefault(
      currencyListByBranch.filter((currency) => currency.is_default)
    );
  }, [currencyListByBranch]);

  useEffect(() => {
    if (changedActiveSection?.section) {
      setActiveSection(changedActiveSection.section);
    }
  }, [changedActiveSection]);

  useEffect(() => {
    setIsMobile(size.width < 1706);
  }, [size.width]);

  useEffect(() => {
    const actions = [
      {
        condition: openManageExternalTrainingModal,
        action: MODAL_CONTENT.MANAGE_EXTERNAL_TRAINING,
      },
      { condition: openSalaryModal, action: MODAL_CONTENT.MANAGE_SALARY },
    ];

    actions.forEach(({ condition, action }) => {
      if (condition) {
        onClickDropdown(action);
      }
    });
  }, [openManageExternalTrainingModal, openSalaryModal]);

  useEffect(
    OnClickOutside(listening, setListening, dropdownRef, () => {
      if (!isMobile) setIsOpen(false);
    })
  );

  useEffect(() => {
    const fetchData = async () => {
      if (missionById?.id) {
        const data = await getModalAccessForMissions({
          missionId: missionById?.id,
        });
        setModalAccessData(data);
      }
    };

    fetchData();
  }, [missionById?.id, getModalAccessForMissions]);

  useEffect(() => {
    const fetchData = async () => {
      if (user?.id) {
        const data = await getModalAccessForDatatrack({
          id: user.id,
        });

        setModalDatatrackAccessData(data);
      }
    };
    fetchData();
  }, [user?.id, getModalAccessForDatatrack]);

  useEffect(() => {
    !id && setReadOnly(true);
    initSection();
  }, [id]);

  const getModalHeaderInfo = (val) => {
    getModalInfo(val);
    return getModalTitle(val);
  };

  const onClickDropdown = (val) => {
    setIsShowing(!isShowing);
    setModalType(val);
    setModalHeaderInfo(getModalHeaderInfo(val));
    setUserDatatrackStatus(QUERY_STATUS.INITIAL);
  };

  useEffect(() => {
    if (isMascarade) {
      mascaradeAs();
      navigate("/perso/dashboard");
    }
  }, [isMascarade]);

  const [pendingModalIntent, setPendingModalIntent] = useState(null);

  useEffect(() => {
    if (openModalIntent && !isShowing) {
      const intent = openModalIntent;
      setModalType(intent);
      setModalHeaderInfo(getModalHeaderInfo(intent));
      setUserDatatrackStatus(QUERY_STATUS.INITIAL);
      setPendingModalIntent(intent);
      setOpenModalIntent && setOpenModalIntent(null);
    }
  }, [openModalIntent]);

  useEffect(() => {
    if (pendingModalIntent && userDatatrackStatus === QUERY_STATUS.SUCCESS) {
      setIsShowing(true);
      setPendingModalIntent(null);
    }
  }, [pendingModalIntent, userDatatrackStatus]);

  useEffect(() => {
    if (!pendingModalIntent) return;
    const timer = setTimeout(() => {
      setIsShowing(true);
      setPendingModalIntent(null);
    }, 500);
    return () => clearTimeout(timer);
  }, [pendingModalIntent]);

  const enableDropdownButton = () => {
    switch (entity) {
      case ENTITY.CLIENT:
        return canUserPerformAction({
          userRoles: clientAccessRights,
          requiredRoles: ACTIONS.UPDATE,
        });
      case ENTITY.BILLING_CLIENT:
        return canUserPerformAction({
          userRoles: billingClientAccessRights,
          requiredRoles: ACTIONS.DELETE,
        });
      case ENTITY.CONSULTANT:
        return canUserPerformAction({
          userRoles: consultantAccessRights,
          requiredRoles: ACTIONS.UPDATE,
        });
      case ENTITY.STAFF:
        return canUserPerformAction({
          userRoles: staffAccessRights,
          requiredRoles: ACTIONS.UPDATE,
        });
      case ENTITY.SUBCONTRACTING_COMPANY:
        return canUserPerformAction({
          userRoles: subcontractingCompanyAccessRights,
          requiredRoles: ACTIONS.UPDATE,
        });
      case ENTITY.SUBCONTRACTOR:
        return canUserPerformAction({
          userRoles: subcontractorAccessRights,
          requiredRoles: ACTIONS.UPDATE,
        });
      case ENTITY.MISSION:
        return canUserPerformAction({
          userRoles: missionAccessRights,
          requiredRoles: ACTIONS.UPDATE,
        });
      default:
        return true;
    }
  };

  useEffect(() => {
    setIsOpen(false);
    setIsOpenMobile(false);
  }, [isMobile]);

  const checkIfOpen = () => {
    if (isOpenMobile || isOpen) {
      return "active";
    }
    return "inactive";
  };

  const canDropdown =
    userScope !== SCOPES.READ &&
    (enableDropdownButton() || hasDatatrackModalAccess);

  const renderDropdownButton = () =>
    canDropdown ? (
      <Button
        className={`btn-outline border-rounded ${checkIfOpen()}`}
        icon={isOpen || isOpenMobile ? "arrow-up" : "arrow-down"}
        onClick={() => {
          if (isMobile) {
            setIsOpenMobile(!isOpenMobile);
          } else setIsOpen(!isOpen);
        }}
        id="entity-dropdown"
      >
        <div className={`dropdown ${checkIfOpen()}`}>
          <Dropdown width={319} marginLeft={-280} marginTop={40}>
            {(isOnFirstTab || entity === ENTITY.MISSION) && (
              <div className="dropdown_edit ">
                <DropdownLinkItem id="update_form_button" onClick={onClickEdit}>
                  <FormattedMessage
                    id="update_form_button"
                    defaultMessage="Modifier la fiche"
                  />
                </DropdownLinkItem>
                <div className="dropdown-separator" />
              </div>
            )}
            {entity === ENTITY.STAFF &&
              staffDropdownList({
                onClickDropdown,
                userBySlug,
                userRoleList,
                entity,
                canMascarade,
                setIsOpenDeleteModal,
                enableMascarade,
                setIsMascarade,
                staffAccessRights,
                modalAccessForDatatrack: modalDatatrackAccessData,
                availableDocuments,
                getDocument,
                lang,
                userScope,
                getDocumentStatus,
              })}
            {entity === ENTITY.CONSULTANT &&
              consultantDropdownList({
                onClickDropdown,
                enableValidateConsultantEmail,
                userRoleList,
                userBySlug: consultantBySlug,
                setIsOpenDeleteModal,
                consultantAccessRights,
                modalAccessForDatatrack: modalDatatrackAccessData,
                availableDocuments,
                getDocument,
                lang,
                userScope,
                getDocumentStatus,
              })}
            {entity === ENTITY.SUBCONTRACTOR &&
              subcontratorDropdownList({
                entity,
                onClickDropdown,
                subcontractorAccessRights,
                setIsOpenDeleteModal,
                modalAccessForDatatrack: modalDatatrackAccessData,
              })}
            {entity === ENTITY.CLIENT &&
              clientDropdownList({
                onDeleteClick: handleClientDeleteClick,
                clientAccessRights,
                onClickDropdown,
                modalAccessForDatatrack: modalDatatrackAccessData,
              })}
            {entity === ENTITY.SUBCONTRACTING_COMPANY &&
              subCompanyDropdownList({
                subcontractingCompanyAccessRights,
                setIsOpenDeleteModal,
                modalAccessForDatatrack: modalDatatrackAccessData,
                getSubcontractorsListExport: () =>
                  getSubcontractorsListExport({
                    company_id: subcontractorCompany?.id,
                    company_name: subcontractorCompany?.company_name,
                  }),
              })}
            {entity === ENTITY.BILLING_CLIENT &&
              billingClientDropDownList({
                setIsOpenDeleteModal,
                billingClientAccessRights,
              })}
            {entity === ENTITY.MISSION &&
              missionDropDownList({
                userRoleList,
                missionById,
                onClickDropdown,
                personsList,
                setIsOpenBackupModal,
                setIsOpenDeleteModal,
                missionIsBackupable,
                userScope,
                getMissionQuote,
                modalAccessForMissions: modalAccessData,
                missionAccessRights,
                availableDocuments,
                getDocument,
                lang,
                handleDownloadMissionPPT,
                getDocumentStatus,
                creationFileStatus,
                missionQuoteStatus,
              })}
          </Dropdown>
        </div>
      </Button>
    ) : (
      <></>
    );

  const getInitialTable = () => {
    switch (modalType) {
      case MODAL_CONTENT.MANAGE_COMPANY_HISTORY:
        return historySubCompany;
      case MODAL_CONTENT.MANAGE_DAILY_FEE:
        return missionFeeByMissionId;
      case MODAL_CONTENT.MANAGE_HISTORY_MANAGERS:
        return missionManagerByMissionId;
      case MODAL_CONTENT.MANAGE_JOB_HISTORY:
        return domainList;
      case MODAL_CONTENT.MANAGE_BILLING_CLIENT_HISTORY:
        return historyBillingClientByClientId;
      case MODAL_CONTENT.MANAGE_EXTERNAL_TRAINING:
        return externalTraining;
      default:
        return userDatatrack;
    }
  };

  const sendValidation = async () => {
    setApiErrorResponse(null);
    setIsOpenValidationModal(true);
    setUserDatatrackStatus(QUERY_STATUS.INITIAL);
    try {
      await onValidate({
        initialTable: getInitialTable() || [],
        editableTable: updatedData,
        elementsToDelete,
        setElementsToDelete,
        type: modalType,
      });
      setUpdatedData([]);
    } catch (error) {
      setIsOpenValidationModal(false);
      console.error("sendValidation error", error);
    }
  };

  const PRACTICE_LEADER_SWITCHBUTTON = (
    <ToggleButton
      id="leader"
      key="leader"
      label={
        <FormattedMessage
          id="practice_leader"
          defaultMessage="Practice leader"
        />
      }
      onChange={() => setIsPracticeLeader(!isPracticeLeader)}
      readOnly={readOnly}
      value={isPracticeLeader}
    />
  );

  const CSE_MEMBER_SWITCHBUTTON = (
    <ToggleButton
      id="cse"
      key="cse"
      label={<FormattedMessage id="cse_member" defaultMessage="CSE member" />}
      onChange={() => setIsCSE(!isCSE)}
      readOnly={readOnly}
      value={isCSE}
    />
  );

  const EOS_CONNECTOR_SWITCHBUTTON = (
    <ToggleButton
      id="enabled"
      key="enabled"
      label={
        <FormattedMessage
          id="eos_connection_authorization"
          defaultMessage="Autorisation connexion EOS"
        />
      }
      onChange={() => setIsEnabled(!isEnabled)}
      readOnly={readOnly}
      value={isEnabled}
    />
  );

  const PARTNER_CONNECTION_SWITCHBUTTON = (
    <ToggleButton
      id="partner_connection"
      key="partner_connection"
      label={
        <FormattedMessage
          id="access_partner_portal"
          defaultMessage="Accès au portail partenaire"
        />
      }
      onChange={() => setIsEnabled(!isEnabled)}
      readOnly={readOnly}
      value={isEnabled}
    />
  );

  const renderRoles = () => {
    if (entity === ENTITY.STAFF || entity === ENTITY.CONSULTANT) {
      return [
        CSE_MEMBER_SWITCHBUTTON,
        PRACTICE_LEADER_SWITCHBUTTON,
        EOS_CONNECTOR_SWITCHBUTTON,
      ];
    } else if (entity === ENTITY.SUBCONTRACTING_COMPANY) {
      return PARTNER_CONNECTION_SWITCHBUTTON;
    }
  };

  const openAppropriateDeleteModal = () => {
    if (timelineMissionsList?.length > 0) {
      setIsOpenWarningModal(true);
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  const handleClientDeleteClick = () => {
    if (
      timelineQueryStatus === QUERY_STATUS.LOADING ||
      timelineQueryStatus === QUERY_STATUS.INITIAL
    ) {
      pendingDeleteRef.current = true;
      return;
    }
    openAppropriateDeleteModal();
  };

  useEffect(() => {
    if (!pendingDeleteRef.current) return;
    if (timelineQueryStatus === QUERY_STATUS.SUCCESS) {
      pendingDeleteRef.current = false;
      if (timelineMissionsList?.length > 0) {
        setIsOpenWarningModal(true);
      } else {
        setIsOpenDeleteModal(true);
      }
    } else if (timelineQueryStatus === QUERY_STATUS.ERROR) {
      pendingDeleteRef.current = false;
      setIsOpenDeleteModal(true);
    }
  }, [timelineQueryStatus, timelineMissionsList]);

  useEffect(() => {
    pendingDeleteRef.current = false;
  }, [id]);

  const onClickEdit = () => {
    setReadOnly(false);
    initSection();
  };

  const displayEditButton = () => {
    if (readOnly) {
      switch (entity) {
        case ENTITY.SUBCONTRACTING_COMPANY:
          return canUserPerformAction({
            userRoles: subcontractingCompanyAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        case ENTITY.STAFF:
          return canUserPerformAction({
            userRoles: staffAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        case ENTITY.CLIENT:
          return canUserPerformAction({
            userRoles: clientAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        case ENTITY.SUBCONTRACTOR:
          return canUserPerformAction({
            userRoles: subcontractorAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        case ENTITY.CONSULTANT:
          return canUserPerformAction({
            userRoles: consultantAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        case ENTITY.BILLING_CLIENT:
          return canUserPerformAction({
            userRoles: billingClientAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        case ENTITY.MISSION:
          return canUserPerformAction({
            userRoles: missionAccessRights,
            requiredRoles: ACTIONS.UPDATE,
          });
        default:
      }
    }
    return false;
  };

  const avatar = (
    <Avatar replace={true} background={robot} size={"medium"} id="robot" />
  );

  const pictureBlock = (
    <InputPicture
      readOnly={readOnly}
      memberPictureToReplace={!!picture}
      value={picture}
      createFile={createFile}
      setCreatedFile={setCreatedFile}
      className="center"
      id="header"
      setCode={setCode}
      setStatus={setStatus}
    />
  );

  const renderHeader = () => {
    switch (entity) {
      case ENTITY.SUBCONTRACTING_COMPANY:
        return avatar;
      case ENTITY.BILLING_CLIENT:
        return;
      case ENTITY.MISSION:
        return;
      case ENTITY.TOOLS:
        return;
      default:
        return pictureBlock;
    }
  };

  const formatCoefOptions = (syntecCoef) =>
    syntecCoef.map((coef) => ({
      value: coef.value,
      label: coef.value,
    }));

  const onCloseHandler = () => {
    const redirectEntity = entity === "mission" ? "missions" : entity;
    setBillingClientStatus(QUERY_STATUS.INITIAL);
    setMissionFeeEditStatus(QUERY_STATUS.INITIAL);
    setMissionManagerStatus(QUERY_STATUS.INITIAL);
    setUserDatatrackStatus(QUERY_STATUS.INITIAL);
    setIsOpenValidationModal(false);
    (_.isNil(apiErrorResponse) || _.isEmpty(apiErrorResponse)) &&
      setIsShowing(false);
    return navigate(`/${userScope}/${redirectEntity}/${entitySlug}`);
  };

  const canEdit = userScope !== SCOPES.READ && displayEditButton();

  return (
    <>
      <ValidationModal
        messages={{
          pendingTitleId: "modal_validation_file_action_msg",
          pendingMessageId: "modal_validation_file_pending_msg",
          successTitleId: "modal_validation_file_action_msg",
          successMessageId: "modal_validation_file_success_msg",
        }}
        open={isOpenValidationModal}
        onClose={onCloseHandler}
        status={entityStatus}
      />
      <Modal
        open={isShowing}
        onClose={() => {
          setIsShowing(false);
          openManageExternalTrainingModal &&
            setOpenManageExternalTrainingModal(false);
          openSalaryModal && setOpenSalaryModal(false);
          setApiErrorResponse(null);
          setUserDatatrackStatus(QUERY_STATUS.INITIAL);
          setUpdatedData([]);
          setElementsToDelete([]);
        }}
        onValidate={sendValidation}
        title={{
          id: modalHeaderInfo?.id,
          defaultMessage: modalHeaderInfo?.defaultMessage,
        }}
        icon={modalHeaderInfo?.icon}
        modalType={modalType}
      >
        {modalType === MODAL_CONTENT.MANAGE_MANAGERS && (
          <ManageManagers
            branches={branches}
            getUpdatedValues={setUpdatedData}
            userManager={userDatatrack}
            lang={lang}
            setElementsToDelete={setElementsToDelete}
            connectedUser={connectedUser}
            managersNames={managersNames}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_HISTORY_MANAGERS && (
          <ManageHistoryManagers
            historyManagers={missionManagerByMissionId}
            usersByIds={usersByIds}
            lang={lang}
            getUpdatedValues={setUpdatedData}
            onValidate={sendValidation}
            missionById={missionById}
            onClose={() => {
              setIsShowing(false);
            }}
            setElementsToDelete={setElementsToDelete}
            isManagerActiveContract={isManagerActiveContract}
            getManagersContract={getManagersContract}
            managersContracts={managersContracts}
            setManagersContracts={setManagersContracts}
            readOnly={!modalAccessData?.fee?.update}
            getNamesByFilters={getNamesByFilters}
            historyManagersNames={historyManagersNames}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_POSITION_COEF && (
          <ManagePositionCoefficient
            entityStatus={entityStatus}
            getUpdatedValues={setUpdatedData}
            userCoefPositionList={userDatatrack}
            userCurrentSalary={user?.salary}
            lang={lang}
            setElementsToDelete={setElementsToDelete}
            contractualStatusList={contractualStatusList}
            syntecCoef={syntecCoef}
            userId={user.id}
            person_id={user.id}
            userScope={userScope}
            userType={user.user_type}
            onValidate={sendValidation}
            onClose={() => {
              setIsShowing(false);
            }}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_SALARY && (
          <ManageSalary
            onClose={() => {
              setIsShowing(false);
            }}
            onValidate={sendValidation}
            entityStatus={entityStatus}
            currencyListByBranch={currencyListByBranch}
            currencyDefault={currencyDefault}
            userSalary={userDatatrack}
            getUpdatedValues={setUpdatedData}
            lang={lang}
            person_id={user.id}
            userScope={userScope}
            setElementsToDelete={setElementsToDelete}
            coefOptions={formatCoefOptions(syntecCoef)}
            userCoefPositionList={userCoefPositionList}
            userType={user.user_type}
            syntecCoef={syntecCoef}
            csltArrivalDate={consultantBySlug?.arrival_date}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_WORK_CONTRACT && (
          <ManageWorkContract
            entityStatus={entityStatus}
            usersByIds={usersByIds}
            userContract={userDatatrack}
            branches={branches}
            reasonLeaveList={leavingReasons}
            lang={lang}
            getUpdatedValues={setUpdatedData}
            onClose={() => {
              setIsShowing(false);
            }}
            onValidate={sendValidation}
            setElementsToDelete={setElementsToDelete}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_LONG_LEAVE && (
          <ManageLongLeave
            entityStatus={entityStatus}
            userVacation={userDatatrack}
            getUpdatedValues={setUpdatedData}
            lang={lang}
            setElementsToDelete={setElementsToDelete}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_JOB_HISTORY && (
          <ManageJobHistory
            entityStatus={entityStatus}
            onValidate={sendValidation}
            onClose={() => {
              setIsShowing(false);
            }}
            jobs={davFunctions}
            usersByIds={usersByIds}
            lang={lang}
            getUpdatedValues={setUpdatedData}
            userJobHistory={domainList}
            setElementsToDelete={setElementsToDelete}
            missionStatus={missionStatus}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_COMPANY_HISTORY && (
          <ManageCompanyHistory
            userScope={userScope}
            subcontractorBySlug={subcontractorBySlug}
            entityStatus={entityStatus}
            companiesByIds={subcontractorCompanies}
            companyHistoryList={historySubCompany}
            getOptions={searchSubcontractorCompanyByName}
            getUpdatedValues={setUpdatedData}
            usersByIds={usersByIds}
            lang={lang}
            setElementsToDelete={setElementsToDelete}
            onValidate={sendValidation}
            onClose={() => {
              setIsShowing(false);
            }}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_DAILY_FEE && (
          <ManageDailyFee
            entityStatus={entityStatus}
            getUpdatedValues={setUpdatedData}
            readOnly={!modalAccessData?.fee?.update}
            lang={lang}
            dailyFeeList={missionFeeByMissionId}
            usersByIds={usersByIds}
            defaultCurrency={defaultCurrency}
            setElementsToDelete={setElementsToDelete}
            onClose={() => {
              setIsShowing(false);
            }}
            onValidate={sendValidation}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_BILLING_CLIENT_HISTORY && (
          <ManageBillingClientHistory
            billingClientHistory={historyBillingClientByClientId}
            billingClientsByName={billingClients}
            billingClientsByIds={billingClientsByIds}
            getOptions={searchBillingClient}
            getUpdatedValues={setUpdatedData}
            usersByIds={usersByIds}
            lang={lang}
            setElementsToDelete={setElementsToDelete}
            userScope={userScope}
            clientBySlug={clientBySlug}
          />
        )}
        {modalType === MODAL_CONTENT.MANAGE_EXTERNAL_TRAINING && (
          <ManageExternalTraining
            entityStatus={entityStatus}
            onValidate={sendValidation}
            onClose={() => {
              setIsShowing(false);
              openManageExternalTrainingModal &&
                setOpenManageExternalTrainingModal(false);
              openSalaryModal && setOpenSalaryModal(false);
            }}
            externalTraining={externalTraining}
            usersByIds={usersByIds}
            getUpdatedValues={setUpdatedData}
            lang={lang}
            setElementsToDelete={setElementsToDelete}
          />
        )}
      </Modal>
      <ClientDeleteWarningModal
        open={isOpenWarningModal}
        onClose={() => setIsOpenWarningModal(false)}
        onValidate={() => {
          setIsOpenWarningModal(false);
          setIsOpenDeleteModal(true);
        }}
      />
      <DeleteModal
        open={isOpenDeleteModal}
        onClose={() => {
          setIsOpenDeleteModal(false);
        }}
        onValidate={() => {
          onDelete(id);
          setIsOpenDeleteModal(false);
        }}
        messageId={getModalMessageId(entity)}
      />
      {entity === ENTITY.MISSION && (
        <BackupModal
          open={isOpenBackupModal}
          onClose={() => {
            setIsOpenBackupModal(false);
          }}
          setMissionCreated={setMissionCreated}
        />
      )}
      <div className="info-header">
        {renderHeader()}
        <div className="header-section ">
          <div className="underlined-div">
            {!(entity === ENTITY.MISSION && !missionById?.analytical_code) && (
              <div className="display-flex">
                <div className="user-div-info">
                  <div className="user-title " id="entity-title">
                    {user?.first_name}
                    {` `}
                    {user?.last_name}
                    {entity === ENTITY.CLIENT && clientBySlug?.name}
                    {entity === ENTITY.SUBCONTRACTING_COMPANY &&
                      subcontractorCompany.company_name}
                    {entity === ENTITY.BILLING_CLIENT &&
                      billingClientBySlug.name}
                    {entity === ENTITY.MISSION && missionById?.name}
                    {entityTagConfig[entity] && (
                      <CategoryTag
                        type={entityTagConfig[entity].type}
                        label={
                          <FormattedMessage
                            id={entityTagConfig[entity].messageId}
                            defaultMessage={
                              entityTagConfig[entity].defaultMessage
                            }
                          />
                        }
                      />
                    )}
                    {entity === ENTITY.CONSULTANT && (
                      <Label
                        className="small"
                        id={missionStatus}
                        color={getMissionStatusColor(missionStatus)}
                        label={
                          <p
                            style={{
                              marginTop: "-10%",
                              fontSize: "18px",
                              fontWeight: "600",
                            }}
                          >
                            {getMissionStatusTagLabel(missionStatus)}
                          </p>
                        }
                      />
                    )}
                  </div>
                  <div className="user-status">{entityFormatters[entity]}</div>
                </div>
                <div id="mobile-btn">{renderDropdownButton()}</div>
              </div>
            )}
            <div className="navigation">
              {INFO_HEADER_NAVIGATION[entity]?.map((elm) => {
                if (
                  elm === HEADER_NAVIGATION.MISSIONS &&
                  !canUserPerformAction({
                    userRoles: userRoleList,
                    requiredRoles: ROLE_GET_TIMELINE,
                  })
                ) {
                  return null;
                }
                if (
                  elm === HEADER_NAVIGATION.CLIENTS &&
                  entity === ENTITY.STAFF &&
                  user?.profile_id !== IA_PROFILE &&
                  user?.profile_id !== MGR_PROFILE &&
                  (!assignedClients || assignedClients?.length === 0)
                ) {
                  return null;
                }
                return (
                  <BorderlessButton
                    key={elm?.label?.id}
                    icon={elm?.icon}
                    label={
                      <FormattedMessage
                        id={elm.label.id}
                        defaultMessage={elm.label.defaultMessage}
                      />
                    }
                    onClick={() => {
                      setSection(elm.section);
                      setActiveSection(elm.section);
                    }}
                    className={activeSection === elm.section ? "active" : ""}
                    id={elm.label.id}
                  />
                );
              })}
            </div>
          </div>
          <div className="user-div-toggle-buttons">{renderRoles()}</div>
        </div>
        {readOnly && !deleted && (
          <div className="user-div-buttons" ref={dropdownRef}>
            {canEdit && (isOnFirstTab || entity === ENTITY.MISSION) && (
              <Button
                className="btn-outline btn-medium"
                onClick={() => onClickEdit()}
                id="entity-enable-update-buttom"
              >
                <FormattedMessage
                  id="update_form_button"
                  defaultMessage="Modifier la fiche"
                />
              </Button>
            )}
            {renderDropdownButton()}
          </div>
        )}
      </div>
    </>
  );
};

export default InfoHeader;

InfoHeader.propTypes = {
  getModalInfo: PropTypes.func,
  onValidate: PropTypes.func,
  modalType: PropTypes.object,
  setModalType: PropTypes.func,
  userDatatrack: PropTypes.array,
  missionFeeByMissionId: PropTypes.array,
  missionManagerByMissionId: PropTypes.array,
  historySubCompany: PropTypes.array,
  subcontractorCompanies: PropTypes.array,
  user: PropTypes.object,
  searchBillingClient: PropTypes.func,
  billingClients: PropTypes.array,
  mascaradeAs: PropTypes.func,
  userScope: PropTypes.string,
  searchSubcontractorCompanyByName: PropTypes.func,
  canMascarade: PropTypes.bool,
  domainList: PropTypes.array,
  historyBillingClientByClientId: PropTypes.array,
  billingClientsByIds: PropTypes.array,
  setElementsToDelete: PropTypes.func,
  elementsToDelete: PropTypes.array,
  getManagersContract: PropTypes.func,
  isManagerActiveContract: PropTypes.func,
  managersContracts: PropTypes.array,
  setManagersContracts: PropTypes.func,
  missionIsBackupable: PropTypes.bool,
  connectedUser: PropTypes.object,
  setCode: PropTypes.func,
  setStatus: PropTypes.func,
  entitySlug: PropTypes.string,
  historyManagersNames: PropTypes.array,
  entityStatus: PropTypes.string,
  managersNames: PropTypes.array,
  userCoefPositionList: PropTypes.array,
};
